import level3ConsumiConsumiFatturati from './level3-03-consumi-01-consumi-fatturati.js';
import level3ConsumiLettureDelContatore from './level3-03-consumi-02-letture-contatore.js';

const data = {
  "consumi-fatturati": {
    label: "Consumi fatturati",
    img: "./images/03-consumi-01-consumifatturati.jpg",
    imgDescription: "Immagine che raffigura la seconda pagina della bolletta, con evidenziata l'area superiore dove sono presenti i consumi fatturati e il dettaglio delle letture.",
    description: "Sono i consumi fatturati in bolletta con un resoconto dei tuoi consumi dell'ultimo anno.",
    labelKeywords: ["consumi", "fatturati"],
    contentKeywords: ["consumi", "fatturati"],
    level3: level3ConsumiConsumiFatturati
  },
  "letture-contatore": {
    label: "Letture del contatore",
    img: "./images/03-consumi-02-letturecontatore.jpg",
    imgDescription: "Immagine che raffigura la seconda pagina della bolletta, con evidenziata l'area Dettaglio letture e la potenza massima rilevata",
    description: "Sezione della bolletta che riporta il dettaglio delle letture del contatore.",
    labelKeywords: ["letture", "lettura", "contatore"],
    contentKeywords: ["letture", "lettura", "contatore"],
    level3: level3ConsumiLettureDelContatore
  }
}

export default data;